import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "lrny_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) =>
  t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// public
export const getSettings = () => client.get("/settings").then((r) => r.data);
export const getQuote = (payload) => client.post("/quote", payload).then((r) => r.data);
export const createBooking = (payload) => client.post("/bookings", payload).then((r) => r.data);
export const autocomplete = (q) =>
  client.get(`/autocomplete?q=${encodeURIComponent(q)}`).then((r) => r.data);

// auth
export const login = (email, password) =>
  client.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => client.get("/auth/me").then((r) => r.data);

// protected
export const listBookings = () => client.get("/bookings").then((r) => r.data);
export const updateBookingStatus = (id, status) =>
  client.patch(`/bookings/${id}/status?status=${status}`).then((r) => r.data);

// airport rates
export const getRates = () => client.get("/rates").then((r) => r.data);
export const getAllRates = () => client.get("/rates/all").then((r) => r.data);
export const createRate = (payload) => client.post("/rates", payload).then((r) => r.data);
export const updateRate = (id, payload) => client.put(`/rates/${id}`, payload).then((r) => r.data);
export const deleteRate = (id) => client.delete(`/rates/${id}`).then((r) => r.data);

// payments (Stripe)
export const createCheckout = (payload) => client.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  client.get(`/payments/status/${sessionId}`).then((r) => r.data);

export default client;
